export default "__VITE_ASSET__CTOZNQTE__"